var map = {
	"./mastercard-black.png": "370e",
	"./mastercard-gold.png": "0239",
	"./mastercard-internacional.png": "86c6",
	"./mastercard-platinum.png": "a4ef",
	"./visa-debito-nacional.png": "1468",
	"./visa-debito-premium-world.png": "f4f2",
	"./visa-debito-premium.png": "5959",
	"./visa-gold.png": "f4fb",
	"./visa-internacional.png": "37b5",
	"./visa-platinum.png": "dd30",
	"./visa-signature.png": "e4d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c39a";